import { CASHBOX_QUERY } from '~/components/Cashbox/enum'
import { IFRAME_EVENT_TYPE } from '~/constants'
import { storageService } from '~/services/index.js'
import { handleCashboxRedirect } from '@/util/cashboxRedirectHandler'

let isFirstCloseIframe = true

export default async ({ app, $config }) => {
  if (process.server) return
  try {
    const scHost = $config.scUrl

    window.addEventListener('message', (event) => {
      if (!!scHost && event.origin === scHost) {
        const migrationToken = storageService.getItem('migrationToken')

        if (!!migrationToken) {
          storageService.removeItem('migrationToken')
        }

        storageService.setItem('migrationToken', event.data?.token)
      }
      /** guard */
      const { router, context: { route } } = app
      if (event?.data?.type !== IFRAME_EVENT_TYPE.beton_close_iframe) return
      if (isFirstCloseIframe) {
        isFirstCloseIframe = false
        return
      }

      if (
        route.query[CASHBOX_QUERY.VIEW.KEY]
        && route.query[CASHBOX_QUERY.VIEW.KEY] !== CASHBOX_QUERY.VIEW.VALUE.IFRAME
      ) return
      /** logic */
      const url = event?.data?.url

      if (!url) {
        console.warn('Beton: no url provided when site opened in the iframe')
        const { view, ...query } = route.query
        router.replace({ query })
        return
      }
      app.$newModal.closeLoaderData()

      let normalizedUrl = url
      if (url.startsWith('https:/') && !url.startsWith('https://')) {
        normalizedUrl = `https://${normalizedUrl.slice(6)}`
      }
      const isInternal = normalizedUrl.startsWith('/') || normalizedUrl.startsWith(window.location.origin)

      if (isInternal) normalizedUrl = normalizedUrl.replace(/^https?:\/\/[^\/]+/, '')

      if (isInternal) {
        const handled = handleCashboxRedirect(normalizedUrl, router, route.query)
        if (!handled) {
          router.replace(normalizedUrl)
        }
      }
      else {
        const handled = handleCashboxRedirect(normalizedUrl, router, route.query)
        if (!handled) {
          window.location.href = normalizedUrl
        }
      }
    })

    const url = window.location.href
    window.parent.postMessage({ type: IFRAME_EVENT_TYPE.beton_close_iframe, url }, '*')
  }
  catch (error) {
    console.warn('Beton message: checkForIframe failed', error)
  }
}
